import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

// Pages
import Dashboard from './pages/Dashboard';
import SensorDetail from './pages/SensorDetail';
import Alarms from './pages/Alarms';
import Sensors from './pages/Sensors';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Login from './pages/Login';

// Components
import Layout from './components/Layout';

// Context
import { useAuth } from './contexts/AuthContext';

function App() {
  const { isAuthenticated, loading, user, login, logout } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)',
        }}
      >
        <CircularProgress sx={{ color: 'white' }} />
      </Box>
    );
  }

  // Autenticazione obbligatoria
  if (!isAuthenticated) {
    return <Login onLogin={login} />;
  }

  return (
    <Layout user={user} onLogout={logout}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/sensor/:sensorId" element={<SensorDetail />} />
        <Route path="/alarms" element={<Alarms />} />
        <Route path="/sensors" element={<Sensors />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/users" element={<Users />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
